export default "__VITE_ASSET__BtQ6DH6p__"